<app-loader *ngIf="isDisabled"></app-loader>
<div class="container">
    <!-- Header -->
    <div class="header">
        <h4><i class="bi bi-calendar-check-fill"></i> Device Attendance Dashboard</h4>
        <div class="header-actions">
            <button type="button" class="export-btn" (click)="GetAttendanceDataExcel()">
                <i class="bi bi-file-earmark-arrow-down"></i> Export Logs
            </button>
            <button type="button" class="export-btn" (click)="ESS_SiteWiseDeviceDetailsSelect(true)">
                <i class="bi bi-file-earmark-arrow-down"></i> Export
            </button>
        </div>
    </div>

    <div class="filter-section">
        <div class="filter-title">Filter Attendance Records</div>
        <form name="FilterForm" (ngSubmit)="FilterValidate(FilterForm)" #FilterForm="ngForm">
            <div class="filter-row">
                <div class="filter-group">
                    <label><i class="bi bi-funnel"></i> Date</label>
                    <select aria-label="Date Type" placeholder="Date Type" title="Date Type" name="Date Type"
                        [(ngModel)]="filter.DateType" #DateType="ngModel" (change)="ClearData()" required>
                        <option value=1>Yesterday</option>
                        <option value=2>Today</option>
                        <option value=5>Monthly</option>
                        <option value=3>Date</option>
                        <option value=4>Date Range</option>
                    </select>
                </div>
                <div class="filter-group" *ngIf="filter.DateType == 5">
                    <label><i class="bi bi-calendar4-event"></i> Month</label>
                    <ngb-datepicker #monthyear name="monthyear" [(ngModel)]="filter.FromDate" class="month-year"
                        (navigate)="filter.FromDate = $event.next;onNavigate($event)"></ngb-datepicker>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>

                <div class="filter-group" style="width:160px" *ngIf="filter.DateType == 3 || filter.DateType == 4">
                    <label><i class="bi bi-calendar4-event"></i> From Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="FromDateObj"
                            [(ngModel)]="filter.FromDate" ngbDatepicker #FromDateObj="ngbDatepicker" required
                            readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select from date!
                    </div>
                </div>
                <div class="filter-group" style="width:160px" *ngIf="filter.DateType == 4">
                    <label><i class="bi bi-calendar4-event"></i> To Date</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="dd-mm-yyyy" name="ToDateObj"
                            [(ngModel)]="filter.ToDate" ngbDatepicker #ToDateObj="ngbDatepicker" required readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDateObj.toggle()"
                            type="button"></button>
                    </div>
                    <div class="invalid-feedback">
                        Please select to date!
                    </div>
                </div>
                <div class="filter-group">
                    <label><i class="bi bi-funnel"></i> Based On</label>
                    <select aria-label="Type" placeholder="Type" title="Type" name="Type"
                        [(ngModel)]="Devicefilter.requestBody.Type" #Type="ngModel" (change)="ClearData()" required>
                        <option value=1>Punch Date</option>
                        <option value=2>Sync Date</option>
                    </select>
                </div>
                <div class="filter-group">
                    <label><i class="bi bi-person-bounding-box"></i> Device</label>
                    <ng-select name="DeviceSerialNo" [items]="DeviceData" bindLabel="serial_num" bindValue="serial_num"
                        [(ngModel)]="this.Devicefilter.requestBody.DeviceSerialNo" placeholder="DeviceSerial No"
                        (change)="ClearData();GetDeviceDetail()" [clearable]="false">
                    </ng-select>
                </div>
                <button class="apply-btn">
                    <i class="bi bi-check2"></i> Apply
                </button>
            </div>
        </form>
    </div>

    <div class="summary-section">
        <div class="summary-card total-punches">
            <div class="card-header">
                <div class="card-title">Total Punches</div>
                <div class="card-icon">
                    <i class="bi bi-person-bounding-box"></i>
                </div>
            </div>
            <div class="card-value"><span class="cursor-pointer" [ngClass]="{'filter-select':FilterIndex == 1}"
                    (click)="FilterData(1); $event.stopPropagation()">{{this.Card.TotalPunch}}</span>
                <div class="punch-breakdown">
                    <div class="breakdown-item cursor-pointer" [ngClass]="{'filter-select':FilterIndex == 1.1}"
                        (click)="FilterData(1.1); $event.stopPropagation()">
                        <div class="breakdown-label color-in">
                            <i class="bi bi-box-arrow-in-right"></i>
                            <span>IN Punches</span>
                        </div>
                        <div class="breakdown-value color-in">{{this.Card.InPunch}}</div>
                        <div class="breakdown-percentage">{{this.Card.InPunchPer}}%</div>
                    </div>

                    <div class="breakdown-item cursor-pointer" [ngClass]="{'filter-select':FilterIndex == 1.2}"
                        (click)="FilterData(1.2); $event.stopPropagation()">
                        <div class="breakdown-label color-out">
                            <i class="bi bi-box-arrow-right"></i>
                            <span>OUT Punches</span>
                        </div>
                        <div class="breakdown-value color-out">{{this.Card.OutPunch}}</div>
                        <div class="breakdown-percentage">{{this.Card.OutPunchper}}%</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="summary-card unique-employees cursor-pointer" [ngClass]="{'filter-select':FilterIndex == 2}"
            (click)="FilterData(2); $event.stopPropagation()">
            <div class="card-header">
                <div class="card-title">Unique Employees</div>
                <div class="card-icon">
                    <i class="bi bi-people-fill"></i>
                </div>
            </div>
            <div class="card-value">{{this.Card.UniqPunch}}</div>
        </div>

        <div class="summary-card sync-rate">
            <div class="card-header">
                <div class="card-title">Sync Success Rate</div>
                <div class="card-icon">
                    <i class="bi bi-arrow-repeat"></i>
                </div>
            </div>
            <div class="card-value"> <span class="cursor-pointer"
                    [ngClass]="{'filter-select':FilterIndex == 3}">{{this.Card.SyncRate}}%</span>
                <div class="punch-breakdown">
                    <div class="breakdown-item cursor-pointer" [ngClass]="{'filter-select':FilterIndex == 3.1}"
                        (click)="FilterData(3.1); $event.stopPropagation()">
                        <div class="breakdown-label color-in">
                            <i class="bi bi-box-arrow-in-right"></i>
                            <span>Sync</span>
                        </div>
                        <div class="breakdown-value color-in">{{this.Card.SyncCount}}</div>
                        <div class="breakdown-percentage">{{this.Card.SyncRate}}%</div>
                    </div>

                    <div class="breakdown-item cursor-pointer" [ngClass]="{'filter-select':FilterIndex == 3.2}"
                        (click)="FilterData(3.2); $event.stopPropagation()">
                        <div class="breakdown-label color-sync">
                            <i class="bi bi-box-arrow-right"></i>
                            <span>Unsync</span>
                        </div>
                        <div class="breakdown-value color-out">{{this.Card.UnSyncCount}}</div>
                        <div class="breakdown-percentage">{{this.Card.UnSyncRate}}%</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="main-content">
        <div class="content-header">
            <h2>Attendance Records ({{this.Devicefilter.requestBody.FromDate}} -
                {{this.Devicefilter.requestBody.ToDate}})</h2>
        </div>
        <table datatable [dtOptions]="this.dtoptions" width="100%" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th style="width: 5px;">#</th>
                    <th style="width: 5px;">View</th>
                    <th>Punch</th>
                    <th style="width: 150px;">Employee Detail</th>
                    <th>Device Serial No</th>
                    <th style="width: 150px;">BSCode</th>
                    <th style="width: 150px;">PunchDate</th>
                    <th style="width: 150px;">SyncSDK Date</th>
                    <th>Sync</th>
                    <th style="width: 50px;">EID</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of Data; let i = index">
                    <th scope="row" style="width: 5px;">{{ i + 1 }}</th>
                    <td style="min-width: 100px;">
                        <button type="button" class="btn btn-outline-primary btn-sm"
                            style="font-size: 0.75rem; padding: 0.25rem 0.5rem;"
                            [routerLink]="['/attendancedevice/device/deviceemployeeattendance/'+element['EmployeeDetailsID']+'/'+element['DeviceSerialNo']]">
                            <i class="bi bi-person-fill me-1"></i> Emp Wise
                        </button>
                    </td>
                    <td style="text-align-last:center" class="cursor-pointer">
                        <img *ngIf="element['PunchImage'] != null && element['PunchImage'] != ''"
                            (click)="common.FullImage(element['PunchImage'],{ProfileImage:(element['ImagePath'] != null && element['ImagePath'] != '')?element['ImagePath']:'data:image/jpeg;base64,'+element['Base64'],Name:element['EmpName'],Code:element['EmpCode']} )"
                            mat-card-image class="userImage" [src]="element['PunchImage']" />
                        <span class="badge"
                            [ngClass]="{'success': this.common.ToLowerCase(element['PunchType']) == 'in','view':this.common.ToLowerCase(element['PunchType']) == 'out'}">
                            {{element['PunchType']}}</span>
                    </td>
                    <td style="width: 300px;">
                        <div class="row" style="align-items: center;" style="align-items: center;width: 300px;">
                            <div class="col-2">
                                <img *ngIf="element['ImagePath'] != null && element['ImagePath'] != ''"
                                    (click)="common.FullImage('',{ProfileImage:element['ImagePath'],Name:element['EmpName'],Code:element['EmpCode']} )"
                                    mat-card-image class="userImage" [src]="element['ImagePath']" />

                                <img *ngIf="(element['ImagePath'] == null || element['ImagePath'] == '') && (element['Base64'] != null && element['Base64'] != '')"
                                    (click)="common.FullImage('',{ProfileImage:'data:image/jpeg;base64,'+element['Base64'],Name:element['EmpName'],Code:element['EmpCode']} )"
                                    mat-card-image class="userImage"
                                    [src]="'data:image/jpeg;base64,'+element['Base64']" />
                            </div>
                            <div class="col-auto">
                                <span class="text-label">{{element['EmpName']}}</span><br />
                                <span class="text-label-light">#{{element['EmpCode']}}</span><br />
                            </div>
                        </div>
                    </td>
                    <td> {{element['DeviceSerialNo']}}</td>
                    <td style="width: 150px;"> {{element['BSCode']}}</td>
                    <td style="width: 150px;"> {{element['PunchDateTime']}}</td>
                    <td style="width: 150px;"> {{element['SyncSDKDate']}}</td>
                    <td style="text-align-last:center"> <span class="badge"
                            [ngClass]="{'warning':element['IsSync'] == 0,'success':element['IsSync']}">
                            {{element['IsSync']?'Yes':'No'}}</span></td>
                    <td style="width: 50px;" class="text-end">{{element['EnrollID']}}</td>
                </tr>
            </tbody>
        </table>
    </div>
    <div class="bottom-action-bar">
        <div class="device-info-card"
            [ngClass]="{'device-info-card-on':this.DeviceInfoCard.status == 1,'device-info-card-off':this.DeviceInfoCard.status == 0}"
            style="width:max-content">
            <div class="device-icon">
                <i class="bi bi-person-bounding-box"></i>
            </div>
            <div class="device-details">
                <h3>{{this.DeviceInfoCard.DeviceSerialNo}} | <i class="bi"
                        [ngClass]="{'bi-wifi':this.DeviceInfoCard.status == 1,'bi-wifi-off':this.DeviceInfoCard.status == 0}"></i>
                    {{this.DeviceInfoCard.status == 0 ?'Offline':'Online'}}</h3>
            </div>
        </div>
        <div class="cancel-back-buttons">
            <button type="button" class="back-btn-bottom" id="backBtn" [routerLink]="['/attendancedevice/device']">
                <i class="fas bi bi-arrow-left"></i>
                Back
            </button>
        </div>
    </div>
</div>